import { createSlice } from '../wrappers';

const initialState = {
	depositValue: 0,
	withdrawValue: 0,
	transferValue: 0,
	transferCardNumber: '',
	taxPaymentValue: 0,
	taxPaymentSelectedId: '',
	taxPaymentDays: 0,
};

const bankSlice = createSlice({
	name: 'bank',
	initialState,
	reducers: {
		setDepositValue: (state, action) => {
			state.depositValue = action.payload;
		},
		setWithdrawValue: (state, action) => {
			state.withdrawValue = action.payload;
		},
		setTransferValue: (state, action) => {
			state.transferValue = action.payload;
		},
		setTransferCardNumber: (state, action) => {
			state.transferCardNumber = action.payload;
		},
		setTaxPaymentValue: (state, action) => {
			state.taxPaymentValue = action.payload;
		},
		setTaxPaymentSelectedId: (state, action) => {
			state.taxPaymentSelectedId = action.payload;
		},
		setTaxPaymentDays: (state, action) => {
			state.taxPaymentDays = action.payload;
		},
	},
});

export const {
	setDepositValue,
	setWithdrawValue,
	setTransferValue,
	setTransferCardNumber,
	setTaxPaymentValue,
	setTaxPaymentSelectedId,
	setTaxPaymentDays,
} = bankSlice.actions;

export default bankSlice.reducer;
